import type {MantineColorScheme} from '@mantine/core'
import type {PropsWithChildren} from 'react'
import {LocalSettingsContext} from './LocalSettingsContext.tsx'
import {useLocalStorageState} from '@mstuercke/react-utils/hooks'

export const LocalSettingsProvider = ({children}: PropsWithChildren) => {
  const [compactMode, setCompactMode] = useLocalStorageState<boolean>('time-track:compact', true)
  const [colorScheme, setColorScheme] = useLocalStorageState<MantineColorScheme>('time-track:color-scheme', 'auto')
  const [showWeekend, setShowWeekend] = useLocalStorageState<boolean>('time-track:show-weekend', false)
  const [showRecommendations, setShowRecommendations] = useLocalStorageState<boolean>(
    'time-track:show-recommendations',
    true,
  )
  const [mergeRecommendations, setMergeRecommendations] = useLocalStorageState<boolean>(
    'time-track:merge-recommendations',
    true,
  )
  const [roundRecommendationTimes, setRoundRecommendationTimes] = useLocalStorageState<boolean>(
    'time-track:round-recommendation-times',
    true,
  )

  return (
    <LocalSettingsContext.Provider
      value={{
        colorScheme,
        setColorScheme,
        compactMode,
        setCompactMode,
        showWeekend,
        setShowWeekend,
        showRecommendations,
        setShowRecommendations,
        mergeRecommendations,
        setMergeRecommendations,
        roundRecommendationTimes,
        setRoundRecommendationTimes,
      }}
    >
      {children}
    </LocalSettingsContext.Provider>
  )
}
